import { BillDetailed, BillVersion } from '@enview/interface/types/bills/Bill';
import {
  faEllipsisV,
  faFilePdf,
  faGlobe,
  faPrint,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import CustomToggleSelectDropDown, {
  CustomToggleDropdownOption,
} from '../Shared/DropDowns/CustomToggleSelectDropDown';

type BillDetailsActionMenuProps = {
  bill: BillDetailed;
  selectedBillVersion?: BillVersion;
};

const BillDetailsActionMenu = (props: BillDetailsActionMenuProps): ReactElement => {
  const { bill, selectedBillVersion } = props;

  const { t } = useTranslation();

  const getDropdownOptions = (): CustomToggleDropdownOption[] => {
    const optionsList: CustomToggleDropdownOption[] = [
      {
        label: t('bill.header.sourceLinkText'),
        value: 2,
        icon: <FontAwesomeIcon color="#979797" icon={faGlobe} />,
        onSelect: () => window.open(bill.sourceUrl),
      },
      {
        label: t('bill.header.printPdf'),
        value: 3,
        icon: <FontAwesomeIcon color="#979797" icon={faPrint} />,
        onSelect: () => window.print(),
      },
    ];

    if (selectedBillVersion?.sourceDocUrl) {
      optionsList.unshift({
        label: t('bill.header.pdfLinkText'),
        value: 1,
        icon: <FontAwesomeIcon color="#979797" icon={faFilePdf} />,
        onSelect: () => window.open(selectedBillVersion.sourceDocUrl),
      });
    }

    return optionsList;
  };

  return (
    <div id="bill-details-action-menu">
      <CustomToggleSelectDropDown
        options={getDropdownOptions()}
        toggle={<FontAwesomeIcon color="#BDBDBD" icon={faEllipsisV} />}
      />
    </div>
  );
};

export default BillDetailsActionMenu;
